import {SelectionRequestJson} from "../../../business/ApiJsonTypes";
import React, {useRef, useState} from "react";


export function SelectionCriteriaUploader(props: { onUpload: (criteria: SelectionRequestJson) => void }) {

    const [inputKeyForComponentReset, setInputKeyForComponentReset] = useState(1);

    // Hiding original for styling
    const hiddenFileInput = useRef<HTMLInputElement>(null);


    const proxyClick = () => {
        if( hiddenFileInput.current == null ) {
            return;
        }
        hiddenFileInput.current.click();
    }

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = e => {
        if (e.target.files === null) {
            console.log("no files selected on change.");
            return;
        }
        const fileReader = new FileReader();
        fileReader.readAsText(e.target.files[0], "UTF-8");
        // Reset on every attempt, not only on success — otherwise re-picking the same file after
        // a rejected load never fires onChange again. FileReader keeps its File reference, so the
        // input remount does not interrupt the read in progress.
        setInputKeyForComponentReset(prev => prev + 1);
        fileReader.onload = e => {
            if (e.target == null || e.target.result == null) {
                alert("Cannot load criteria");
                return;
            }

            let json: string;
            if (e.target.result instanceof ArrayBuffer) {
                json = new TextDecoder().decode(e.target.result)
            } else {
                json = e.target.result;
            }

            try {
                acceptCriteriaFileContent(json, props.onUpload);
            } catch (error) {
                console.error("Failed to parse criteria file:", error);
                alert("Cannot load criteria: invalid JSON file");
            }
        };
    };
    return (
        <>
            <button className={"btn btn-sm btn-outline btn-outline-primary"} onClick={proxyClick}><i className="fas fa-folder-open"></i></button>
            <input ref={hiddenFileInput} style={{ display: "none" }}  key={inputKeyForComponentReset} type="file" onChange={handleChange} accept=".json"/>
        </>
    );
}

function acceptCriteriaFileContent(json: string, onUpload: (criteria: SelectionRequestJson) => void) {
    const parsed: any = JSON.parse(json);
    if (!parsed.hasOwnProperty("criteriaVersion")) {
        alert("Cannot load criteria: no version");
        return;
    }
    if (parsed.criteriaVersion !== 1) {
        alert("Cannot load criteria: unsupported criteria file version");
        return;
    }
    console.log("Parsed uploaded criteria: ", parsed);
    const {criteriaVersion, ...cleanCriteria} = parsed;
    onUpload({...cleanCriteria, signalIdentifier: "" + Math.random()});
}